/**
 * Escapes HTML-special characters in the given string so it can be safely
 * inserted into markup.
 *
 * @param  {String} string
 *         String to escape.
 * @return {String}
 *         Escaped string.
 */
export function escapeHtml(string) {

    return string
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");

}

/**
 * Removes any HTML markup from the given string.
 *
 * @param  {String} string
 *         String from which HTML markup should be removed.
 * @return {String}
 *         String without any HTML markup.
 * @see    https://css-tricks.com/snippets/javascript/strip-html-tags-in-javascript/
 */
export function striptags(string) {
    return String(string).replace(/(<([^>]+)>)/gi, "");
}

/**
 * A simple function that converts the double asterists into strong tags.
 *
 * @param  {String} string
 *         Text to convert.
 * @return {String}
 *         Converted text.
 */
export function markdown2html(string) {
    return string.replace(/\*\*([^*]*)\*\*/g, "<strong>$1</strong>");
}

/**
 * Replaces placeholders in the given string with the replacements provided.
 *
 * @param  {String} template
 *         String with placeholders to replace.
 * @param  {Array|Object} replacements
 *         Replacements to populate the string.
 * @return {String}
 *         String with replacements.
 */
export function supplant(template, replacements) {

    return template.replace(/\{([^{}]*)\}/g, (whole, index) => (
        Object.prototype.hasOwnProperty.call(replacements, index)
        ? replacements[index]
        : whole
    ));

}

/**
 * Generates a UUID (v4)
 *
 * @return {String}
 *         UUID
 */
export function makeUUID() {
    if (typeof window.crypto?.randomUUID === "function") {
        return window.crypto.randomUUID();
    }

    // https://stackoverflow.com/a/2117523
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
        (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
    );
}
